module.exports = __webpack_public_path__ + "images/5c7b7ef15a7ce58e204605fc9c6aeda5.jpg";


//////////////////
// WEBPACK FOOTER
// ./webpack/assets/img/wheels-locations06.jpg
// module id = ./webpack/assets/img/wheels-locations06.jpg
// module chunks = 0